import { render } from "./TicketsPage.vue?vue&type=template&id=06727dd2&scoped=true"
import script from "./TicketsPage.vue?vue&type=script&lang=js"
export * from "./TicketsPage.vue?vue&type=script&lang=js"

import "./TicketsPage.vue?vue&type=style&index=0&id=06727dd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06727dd2"]])

export default __exports__